import { useEffect, useRef, useState } from "react";
import AppService from "../../services/app/app.service";

export const useHomeHook = () => {
  const [homePageData, setHomePageData] = useState(null);
  const appService = new AppService();
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchedRef = useRef(false);
  useEffect(() => {
    if (fetchedRef.current) return; // guard against React StrictMode double-invoke
    fetchedRef.current = true;
    (async () => {
      try {
        const result = await appService.getPage("home");
        setHomePageData(result.data);
        setError(result.error);
        setIsLoading(result.isLoading);
      } catch (e: any) {
        setError(e);
        setIsLoading(false);
      }
    })();
  }, []);

  return {
    homePageData,
    error,
    isLoading,
  };
};
